<nav-bar></nav-bar>
<div class="content-wrap" *ngIf="isLoggedIn">
    <router-outlet></router-outlet>
</div>
<footer-component></footer-component>


